import React from "react";
import { CgSpinner } from "react-icons/cg";

const ActionButton = ({
  icon,
  onClick,
  title,
  disabled = false,
  loading = false,
  sizeChange = true,
  variant = "default",
  className = "",
}) => {
  const baseClasses = "w-7 h-7 md:w-9 md:h-9 flex items-center justify-center rounded-[6px] transition-all";

  const variantClasses = {
    default: `bg-white border text-blue ${disabled || loading
      ? "opacity-50 cursor-not-allowed border-gray-200"
      : "border-blue/20 hover:bg-blue/10 hover:border-blue/30"
      }`,
    danger: `text-red-500 hover:text-red-700 hover:bg-red-50 border border-transparent hover:border-red-100 ${disabled || loading ? "opacity-50 cursor-not-allowed" : ""}`,
    primary: `bg-blue/10 text-blue border border-blue/20 hover:bg-blue/20 ${disabled || loading ? "opacity-50 cursor-not-allowed" : ""}`,
    success: `bg-green-50 text-green-600 border border-green-200 hover:bg-green-100 ${disabled || loading ? "opacity-50 cursor-not-allowed" : ""}`,
    warning: `bg-amber-50 text-amber-600 border border-amber-200 hover:bg-amber-100 ${disabled || loading ? "opacity-50 cursor-not-allowed" : ""}`,
    info: `bg-sky-50 text-sky-600 border border-sky-200 hover:bg-sky-100 ${disabled || loading ? "opacity-50 cursor-not-allowed" : ""}`,
    secondary: `bg-gray-50 text-gray-600 border border-gray-200 hover:bg-gray-100 ${disabled || loading ? "opacity-50 cursor-not-allowed" : ""}`,
  };

  const renderIcon = () => {
    if (loading) {
      return <CgSpinner size={20} className="animate-spin" />;
    }
    if (!sizeChange) {
      return icon;
    }
    if (React.isValidElement(icon)) {
      return React.cloneElement(icon, { size: 24 });
    }
    return icon;
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
      title={title}
    >
      {renderIcon()}
    </button>
  );
};

export default ActionButton;
